<div class="min-vh-100">
  <app-candidat-header></app-candidat-header>
  <div class="candidat-container">
    <router-outlet></router-outlet>

  </div>
</div>
<ng-container *ngIf="isChatActive">
  <button class="floating-chat-button" (click)="toggleChat()" [title]="totalUnreadCount > 0 ? totalUnreadCount + ' message(s) non lu(s)' : 'Ouvrir la messagerie'">
    <svg-icon src="assets/icons/send-white.svg"></svg-icon>
    <span class="chat-badge" *ngIf="totalUnreadCount > 0">{{ totalUnreadCount }}</span>
  </button>
  <app-chat-popup *ngIf="isChatOpen" (closeChat)="toggleChat()"></app-chat-popup>
</ng-container>
